import { UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import { StyledRow } from "Pages/MyBatchesAntd/MyBatchesHeaderAntd";
import { filterOption } from "Pages/PlannerView/PlannerFilterFormFieldComp";
import { Col, Form, Select } from "antd";
import React, { useContext } from "react";
import { Medium } from "utilFunctions/Constants/Constants";
interface MyLibraryFilterFieldsCompIF {
  filterState: any;
  form: any;
  onChange: any;
  isRequired: boolean;
}
const MyLibraryFilterFieldsComp = ({
  filterState,
  onChange,
  isRequired,
}: MyLibraryFilterFieldsCompIF) => {
  const { masters } = useMasterContext();
  const userInfo = useContext<any>(UserInfoContext);
  return (
    <StyledRow gutter={[10, 0]} screen={screen}>
      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item
          label="Stream"
          name="sid"
          rules={[{ required: isRequired, message: "Please select stream" }]}
        >
          <Select
            showSearch
            defaultValue={filterState.sid ? filterState.sid : null}
            style={{ width: "100%" }}
            size="middle"
            options={masters?.streams}
            onChange={(val) => onChange("sid", val)}
            filterOption={filterOption}
          />
        </Form.Item>
      </Col>
      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item
          label="Class"
          name={"cid"}
          rules={[{ required: isRequired, message: "Please select Class" }]}
        >
          <Select
            showSearch
            options={masters?.classes}
            placeholder=""
            defaultValue={filterState.cid ? filterState.cid : null}
            onChange={(val) => onChange("cid", val)}
            filterOption={filterOption}
          ></Select>
        </Form.Item>
      </Col>

      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item label="Subject" name={"sjId"}>
          <Select
            showSearch
            options={userInfo?.subjectsListing}
            placeholder=""
            defaultValue={filterState.sjId ? filterState.sjId : null}
            onChange={(val) => onChange("sjId", val)}
            filterOption={filterOption}
          ></Select>
        </Form.Item>
      </Col>

      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item label="Board" name={"bid"}>
          <Select
            showSearch
            options={masters?.boards}
            placeholder=""
            defaultValue={filterState.bid ? filterState.bid : null}
            onChange={(val) => onChange("bid", val)}
            filterOption={filterOption}
          ></Select>
        </Form.Item>
      </Col>
      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item
          label="Academic year"
          name={"ayId"}
          rules={[
            { required: isRequired, message: "Please select academic year" },
          ]}
        >
          <Select
            showSearch
            defaultValue={filterState.ayId ? filterState.ayId : null}
            style={{ width: "100%" }}
            size="middle"
            options={masters?.acadYears}
            onChange={(val) => onChange("ayId", val)}
            filterOption={filterOption}
          />
        </Form.Item>
      </Col>

      <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item label="Medium" name={"lang"}>
          <Select
            showSearch
            options={Medium}
            placeholder=""
            defaultValue={filterState.lang ? filterState.lang : null}
            onChange={(val) => onChange("lang", val)}
            filterOption={filterOption}
          ></Select>
        </Form.Item>
      </Col>
    </StyledRow>
  );
};

export default MyLibraryFilterFieldsComp;
